import React, { useState, useEffect, MouseEventHandler } from "react";
import relativeTime from "dayjs/plugin/relativeTime";
import localizedFormat from "dayjs/plugin/localizedFormat";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CompanyAvatar from "../Avatars/CompanyAvatar";
import { ChatMessageType } from "../../interfaces/chats";
import { DateFormatter } from "../../functions/commons";
import {
  DATE_FORMAT5,
  DATE_FORMAT6,
  TIME_FORMAT1,
} from "../../constants/stringConstants";
import AcceptInterviewModal from "./AcceptInterviewModal";
import { Modal } from "antd";
import LocationDescription from "../../features/chats/LocationDescription";
import { addToGoogleCalendar } from "../../hooks/functions/useAddToGoogleCalendar";
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

interface InterviewInviteMessagePropType {
  chat: ChatMessageType;
  refreshList: Function;
  profileImage: string;
}

function InterviewInviteMessage(props: InterviewInviteMessagePropType) {
  const { chat, refreshList, profileImage } = props;
  const [acceptInterviewModal, setAcceptInterviewModal] = useState(false);
  const [modalLocationVisible, setModalLocationVisible] = useState(false);

  const closeModal = () => {
    setAcceptInterviewModal(false);
  };

  const handleAddToCalendar = () => {
    const event = {
      summary: "My Event",
      description: "This is a sample event",
      start: {
        dateTime: "2023-06-10T09:00:00",
        timeZone: "America/New_York",
      },
      end: {
        dateTime: "2023-06-10T10:30:00",
        timeZone: "America/New_York",
      },
      location: "New York",
    };

    addToGoogleCalendar(event);
  };

  return (
    <>
      <div style={{ marginBottom: "23px" }}>
        <div className="invite_interview_sec">
          <div className="tafm-from-msg-div__img-msg">
            {!profileImage ? <CompanyAvatar /> : <img src={profileImage} />}
          </div>
          <div className="invite_interview_content_sec">
            <div style={{ paddingLeft: "10px" }}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <text className="blue_color_text">
                  {chat?.interview ? chat.interview?.interviewType : "Remote"}{" "}
                  Interview
                </text>
                <text className="interview_invite_content_text_style">
                  Your interview has been scheduled at
                </text>
              </div>

              <div style={{ marginTop: "10px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "5px",
                  }}
                >
                  <CalendarMonthOutlinedIcon className="invite_interview_icon" />
                  <text style={{ fontSize: "12px" }}>
                    {chat?.interview
                      ? DateFormatter(chat.interview?.date, DATE_FORMAT6)
                      : `April,30 2022`}
                  </text>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <QueryBuilderIcon className="invite_interview_icon" />
                  <text style={{ fontSize: "12px" }}>
                    {chat?.interview
                      ? `${DateFormatter(
                          chat.interview?.startTime,
                          TIME_FORMAT1
                        )} (${chat.interview?.endTime}mins)`
                      : `10:59PM (30min)`}
                  </text>
                </div>
              </div>
            </div>
            <div className="invite_interview_btn_sec">
              <text
                className="invite_interview_btn invite_btn_first blue_color_text"
                onClick={handleAddToCalendar}
              >
                Add to Calender
              </text>
              <text
                className="invite_interview_btn invite_btn_second blue_color_text"
                onClick={() => {
                  chat.interview?.interviewType === "Remote"
                    ? window.open(`https://${chat?.interview?.link}`, "_blank")
                    : setModalLocationVisible(false);
                }}
              >
                {chat.interview?.interviewType === "Remote"
                  ? "Join Meeting"
                  : "View Location"}
              </text>
            </div>
          </div>
        </div>
        <div
          onClick={() => {
            !chat?.interview?.isInterviewInviteAccepted &&
              setAcceptInterviewModal(true);
          }}
          className={`${
            chat?.interview?.isInterviewInviteAccepted
              ? "invite_interview_accepted"
              : "invite_interview_main_btn"
          }`}
        >
          <text>
            {chat?.interview
              ? chat?.interview?.isInterviewInviteAccepted
                ? "You have accepted the interview"
                : "Accept Interview"
              : "Accept Interview"}
          </text>
        </div>
      </div>

      {modalLocationVisible && (
        <Modal
          footer={null}
          visible={true}
          className="ant-modal"
          onCancel={(e) => {
            setModalLocationVisible(false);
          }}
        >
          <LocationDescription
            onCloseDescriptionModal={() => {
              setModalLocationVisible(false);
            }}
            companyName={""}
            companyTitle={""}
            interviewDate={""}
            locationAddress={""}
          />
        </Modal>
      )}

      {acceptInterviewModal && (
        <AcceptInterviewModal
          chat={chat}
          closeModal={closeModal}
          refreshList={refreshList}
        />
      )}
    </>
  );
}

export default InterviewInviteMessage;
